<template >
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path v-if="!checked" d="M21,3H3v18h18V3z" />
      <path v-else d="M21 3H3v18h18V3zM10 17.414l-4.707-4.707 1.414-1.414L10 14.586l7.293-7.293 1.414 1.414L10 17.414z"/>
  </svg>
</template>


<script>
export default {
  props: {
    checked: Boolean
  }
};
</script>

<style>
</style>
